export const DEFAULT_CART_PROMOTION_BADGE = {
  backgroundColor: '#dc2626',
  textColor: '#ffffff',
  useGradient: false,
  gradientFrom: '#dc2626',
  gradientTo: '#b91c1c',
  gradientAngle: 90,
};

export const buildCartPromotionBadgeStyle = (config) => {
  const merged = { ...DEFAULT_CART_PROMOTION_BADGE, ...(config || {}) };
  const background = merged.useGradient
    ? `linear-gradient(${merged.gradientAngle}deg, ${merged.gradientFrom}, ${merged.gradientTo})`
    : merged.backgroundColor;

  return {
    background,
    color: merged.textColor,
  };
};

export const formatCartPromotionLabel = (percent) => `Sepette %${percent} indirim`;

export const applyCartPromotionBadgeCssVars = (config) => {
  if (typeof document === 'undefined') return;

  const merged = { ...DEFAULT_CART_PROMOTION_BADGE, ...(config || {}) };
  const root = document.documentElement;
  const background = merged.useGradient
    ? `linear-gradient(${merged.gradientAngle}deg, ${merged.gradientFrom}, ${merged.gradientTo})`
    : merged.backgroundColor;

  root.style.setProperty('--cart-promo-badge-bg', background);
  root.style.setProperty('--cart-promo-badge-text', merged.textColor);
};
